import React from "react";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import { BnbLabel } from "../../../utils/labels";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as ServicePlanTagStyles from "../../../../../../common-deprecated/styles/toyota/ServicePlanTag";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import type { PriceType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../redux/store";
import Price from "../common/price/Price";
import * as Styles from "./styles/Summary";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { showPrice } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";

type SummaryRowPropsType = {
    text: string;
    price?: PriceType;
    itemId?: string;
    financeable?: boolean;
    exclusiveOnline?: boolean;
    onRemove?: () => void;
    popoverContent?: string | false;
};

const SummaryRow = (props: SummaryRowPropsType): JSX.Element => {
    const showPrices = useBnbSelector((state) => showPrice(state.commonSettings));
    const showNonFinanceableTag = props.financeable === false;

    return (
        <Styles.Row>
            <Flex.Row justifyContent="space-between" flexWrap="nowrap" data-testid="summary-row">
                <Flex.Col>
                    <span dangerouslySetInnerHTML={{ __html: props.text }} />
                    {props.popoverContent && <Popover showOnClick content={props.popoverContent} />}
                    <ServicePlanTagStyles.Tags>
                        {showNonFinanceableTag && (
                            <ServicePlanTagStyles.Tag>
                                <BnbLabel label="nonFinanceableServicePlans" />
                            </ServicePlanTagStyles.Tag>
                        )}
                        {props.exclusiveOnline && (
                            <ServicePlanTagStyles.Tag>
                                <BnbLabel label="exclusiveOnlineServicePlans" />
                            </ServicePlanTagStyles.Tag>
                        )}
                    </ServicePlanTagStyles.Tags>
                </Flex.Col>

                {(props.price || props.onRemove) && (
                    <Styles.PriceCol>
                        {props.price && (
                            <>
                                {props.price.discount === 0 && props.price.cash === 0 ? (
                                    showPrices && <BnbLabel label="standard" />
                                ) : (
                                    <Price price={props.price} financeItemId={props.itemId} />
                                )}
                            </>
                        )}
                        {props.onRemove && (
                            <Button.Link onClick={props.onRemove} data-testid="remove-button">
                                <IconWrapper>
                                    <Icon variant="close" />
                                </IconWrapper>
                            </Button.Link>
                        )}
                    </Styles.PriceCol>
                )}
            </Flex.Row>
        </Styles.Row>
    );
};

export default SummaryRow;
